<template>
  <v-dialog persistent  width="800" v-model="$store.state.showDownloadProductsDialog">
    <v-card v-if="detailInfo !== ''" style="width: 100%;height: 570px;position: relative">
      <!--顶部-->
      <div style="height: 70px;font-size: 24px;line-height: 70px;font-weight: 700;text-align: center">
        影像集下载
        <span @click="closeProductsDialog" class="iconfontFamily" style="font-size: 15px;color: rgba(166, 166, 166, 1);position: absolute;right: 30px;cursor: pointer">&#xe60d;</span>
      </div>
      <v-divider style="background-color: rgba(229, 229, 229, 1)"></v-divider>
      <!--内容-->
      <div style="padding-left: 50px;padding-right: 50px;height: 417px">
        <div class="d-flex">
          <div style="font-size: 18px;font-weight: 700;line-height: 70px;height: 60px">
            {{detailInfo.imageCollection.title}}
          </div>
          <div v-show="detailInfo.buyStatus === 1" style="display: flex">
            <span class="iconfontFamily" style="font-size: 14px;color: rgba(17, 170, 102, 1);margin-left: 20px;line-height: 70px">&#xe635;</span>
            <div  style="font-size: 14px;line-height: 70px;margin-left: 5px">已购买</div>
          </div>
        </div>
        <v-divider style="background-color: rgba(229, 229, 229, 1)"></v-divider>
        <div style="font-size: 16px;margin-top: 15px">素材列表</div>
        <div v-if="imageList.length > 0">
          <div style="font-size: 14px;margin-top: 14px;color: rgba(128, 128, 128, 1)">图片×{{imageList.length}}</div>
          <div style="display: flex;margin-top: 17px;overflow: auto">
            <div v-for="(item,index) in imageList" :key="index">
              <img style="width: 100px;height: 100px;display: block" :src="detailInfo.zMaterials[item].jpgThumb" :style="{'margin-right': index === imageList.length - 1 ? '0' : '50px'}">
            </div>
          </div>
        </div>
        <div v-if="threeDCount > 0" style="font-size: 14px;margin-top: 17px;color: rgba(128, 128, 128, 1)">3D视频×{{threeDCount}}</div>
        <div v-if="compareCount > 0" style="font-size: 14px;margin-top: 14px;color: rgba(128, 128, 128, 1)">卷帘素材×{{compareCount}}</div>
      </div>
      <v-divider style="background-color: rgba(229, 229, 229, 1)"></v-divider>
      <!--底部-->
      <div v-if="!verifySuccess" style="padding-top: 15px;padding-right: 50px;padding-left: 50px;display: flex">
        <div>
          <div class="d-flex">
            <div style="font-size: 16px;">账户余额：{{detailInfo.coupon}}</div>
            <div style="font-size: 16px;margin-left: 50px">消耗下载券</div>
            <span class="iconfontFamily" style="font-size: 20px;color: rgba(42, 130, 228, 1);margin-left: 12px;margin-top: -3px">&#xe643;</span>
            <div style="font-size: 16px;margin-left: 2px">x{{ detailInfo.buyStatus === 1 ? 0 :  detailInfo.imageCollection.price}}</div>
          </div>
          <div class="d-flex">
            <span class="iconfontFamily" style="font-size: 14px;color: rgba(166, 166, 166, 1);">&#xe612;</span>
            <div style="color: rgba(166, 166, 166, 1);font-size: 14px;margin-left: 4px">下载即同意<span @click="gotoImageAndAgreement" style="color: rgba(25, 118, 210, 1);cursor: pointer">《吉林一号·共生地球影像授权服务协议》</span></div>
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-btn @click="download()" width="100" height="40" color="rgba(30, 64, 175, 1)" style="color: white;margin-top: 6px">
          确认下载
        </v-btn>
      </div>
      <div v-if="verifySuccess" >
        <div style="margin: 24px auto 0 auto;width: max-content;height: 30px;" class="d-flex">
          <span class="iconfontFamily" style="font-size: 14px;color: rgba(17, 170, 102, 1);line-height: 30px">&#xe635;</span>
          <div style="font-size: 14px;line-height: 30px;margin-left: 5px">验证成功，正在开启下载……</div>
        </div>
      </div>
      <!--影像集未购买toast-->
      <div v-if="showSnackBar" style="position:absolute;left:50%;top:8px;transform:translate(-50%,0);height:32px;background:#FFC300;padding:0 30px;">
        <p style="line-height:32px;color:#ffffff;font-size:16px;">余额不足</p>
      </div>


<!--      <v-snackbar v-model="showSnackBar" width="150" height="32" color="rgba(255, 195, 0, 1)" absolute top :timeout="1000"><span  class="iconfontFamily" style="width: 150px;font-size: 16px;color: white;text-align: center;"> &#xe649;</span>余额不足</v-snackbar>-->
    </v-card>
    <pay-verify ref="payVerify" :download-product="downLoadProduct"></pay-verify>
  </v-dialog>
</template>

<script>
import PayVerify from "@/components/download_products/PayVerify";
export default {
  name: "DownloadProducts",
  components: {PayVerify},
  data(){
    return {
      imageList:[],
      verifySuccess:false,
      detailInfo:'',
      threeDCount:0,
      compareCount:0,
      showSnackBar:false,
    }
  },
  props:['mainId'],
  mounted() {
    this.getDetailsById()
  },
  methods:{
    closeProductsDialog(){
      this.$store.commit('setShowDownloadProductsDialog',false);
    },
    download(){
      if(this.detailInfo.buyStatus === 0){
        this.showPayDialog()
      }else{
        this.downloadZip()
      }
    },
    showPayDialog(){
      this.$refs.payVerify.showPayVerifyDialog = true
    },
    getDetailsById(){
      this.$axios({
        method:"get",
        url:'/authorApi/z-image-collection/getById',
        params:{
          'mainId':this.mainId
        }
      }).then((resultData)=>{
        if(resultData.data.status === 200){
          this.detailInfo = resultData.data.data
          for(let i = 0; i < this.detailInfo.zMaterials.length; i++){
            if(this.detailInfo.zMaterials[i].type === 1){
              this.imageList.push(i)
            }else if(this.detailInfo.zMaterials[i].type === 2){
              this.threeDCount ++
            }else{
              this.compareCount ++
            }
          }
        }
      })
    },
    async downLoadProduct() {
      let data = new FormData()
      data.append('imageId', this.mainId)
      let resultData = await this.$axios({
        method: "post",
        url: '/authorApi/z-user-order/buy', data
      })
      if (resultData.data.status === 200) {
        this.verifySuccess = true;
        this.downloadZip()
      }else if(resultData.data.status === 307){
        this.showSnackBar = true
        setTimeout(()=>{
          this.showSnackBar = false
        },1000)
      }
    },
    downloadZip(){
      this.$axios({
        method:"get",
        url:'/authorApi/z-image-collection/getZipLink',
        params:{
          'mainId':this.mainId
        }
      }).then((res)=>{
        // const link = document.createElement('a');
        // link.setAttribute('download','')
        // link.href = res.data.data
        // // link.setAttribute('onclick','return false;')
        // link.click()


        //避免下载造成页面跳转，有离开页面提示
        var download_file= {}
        if (typeof(download_file.iframe) == "undefined") {
          var iframe = document.createElement("iframe");
          download_file.iframe = iframe;
          document.body.appendChild(download_file.iframe);
        }
        download_file.iframe.src = res.data.data
        download_file.iframe.style.display = "none";

      })

    },
    gotoImageAndAgreement(){
      let path = this.$router.resolve({
        path: '/documentPage',query:{
          pageType:'imageUserAgreement'
        }
      })
      window.open(path.href,'_blank')
    },
  }
}
</script>

<style scoped>

</style>